// src/pages/xray/XrayLobby/TabProtocolSIP.js
import React from 'react';

const TabProtocolSIP = ({
  selectedTabsSIP,
  setSelectedTabsSIP,
  sipServerLimits,
  sipClientsLimits,
  sipProxyPort,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['SIP Servers', 'SIP Clients', 'SIP Proxy Port'].map(
          (label, index) => (
            <label
              key={index}
              className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
                selectedTabsSIP === `tabsSIP${index + 1}`
                  ? 'border-b-0 font-bold'
                  : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
              }`}
            >
              <input
                type="radio"
                className="hidden"
                name="tabs-group"
                checked={selectedTabsSIP === `tabsSIP${index + 1}`}
                onChange={() => setSelectedTabsSIP(`tabsSIP${index + 1}`)}
              />
              {label}
            </label>
          )
        )}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsSIP === 'tabsSIP1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">SIP Servers</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {sipServerLimits || 'No SIP Servers status available'}
            </pre>
          </div>
        )}

        {selectedTabsSIP === 'tabsSIP2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              SIP Clients - confirm IP addresses of the Voice VLAN
            </h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {sipClientsLimits || 'No SIP Clients status available'}
            </pre>
          </div>
        )}

        {selectedTabsSIP === 'tabsSIP3' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              SIP Proxy Port - EPBX9 uses 5075
            </h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {sipProxyPort || 'No SIP Proxy Port status available'}
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default TabProtocolSIP;
